<template>
  <div class="backdrop">
    <div class="modal">
      <span
        class="close"
        @click="closeModal"
      >
        <img
          src="~/assets/icons/close.svg"
          width="14"
          height="14"
          alt="Close icon"
        />
      </span>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useAppStore } from '~/stores'
  const appStore = useAppStore()

  const closeModal = () => {
    appStore.showModal(false)
    appStore.showPP(false)
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .backdrop {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba($black, 0.4);
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 999;
    pointer-events: none;

    .modal {
      background: white;
      border-radius: 8px;
      position: relative;
      z-index: 9999;
      pointer-events: all;
      padding: 0 40px;

      @include tablet-up {
        padding: 80px 40px;
      }
    }

    .close {
      position: fixed;
      top: 16px;
      right: 16px;
      width: 32px;
      height: 32px;
      border-radius: 16px;
      background: #f6f7f8;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      @include tablet-up {
        position: absolute;
      }

      &:hover {
        background: $light-grey;
      }
    }
  }
</style>
